import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  close1s6qtnweux4fu as close,
  ObjectPool3iks1t8z0qq3m as ObjectPool,
} from './Pool.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultPoolClass;
function DefaultPool() {
  if (DefaultPoolClass === VOID) {
    class $ {
      constructor(capacity) {
        this.n4l_1 = capacity;
        var tmp = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.n4l_1;
        tmp.o4l_1 = Array(size);
        this.p4l_1 = 0;
      }
      q4l(instance) {
      }
      r4l(instance) {
        return instance;
      }
      s4l(instance) {
      }
      t4l() {
        if (this.p4l_1 === 0)
          return this.m4l();
        this.p4l_1 = this.p4l_1 - 1 | 0;
        var idx = this.p4l_1;
        var tmp = this.o4l_1[idx];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.o4l_1[idx] = null;
        return this.r4l(instance);
      }
      u4l(instance) {
        this.s4l(instance);
        if (this.p4l_1 === this.n4l_1) {
          this.q4l(instance);
        } else {
          var _unary__edvuaz = this.p4l_1;
          this.p4l_1 = _unary__edvuaz + 1 | 0;
          this.o4l_1[_unary__edvuaz] = instance;
        }
      }
      jz() {
        var inductionVariable = 0;
        var last = this.p4l_1;
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.o4l_1[i];
            var instance = !(tmp == null) ? tmp : THROW_CCE();
            this.o4l_1[i] = null;
            this.q4l(instance);
          }
           while (inductionVariable < last);
        this.p4l_1 = 0;
      }
    }
    protoOf($).l6 = close;
    initMetadataForClass($, 'DefaultPool', VOID, VOID, [ObjectPool()]);
    DefaultPoolClass = $;
  }
  return DefaultPoolClass;
}
//region block: exports
export {
  DefaultPool as DefaultPool2gb1fm4epwgu9,
};
//endregion

//# sourceMappingURL=DefaultPool.mjs.map
